import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Chip, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { getEquipmentPartsWithSensorPositionByQuery } from "components/axios/equipmentAxios";
import MainCard from "components/MainCard";
import EquipmentPanel from "./EquipmentPanel";
import EquipmentPartChainGraphs from "./chart/EquipmentPartChainGraphs";
import EquipmentPartSensorsGraphs from "./chart/EquipmentPartSensorsGraphs";
import EquipmentPartsReplaceLayer from "../layer/EquipmentPartsReplaceLayer";

const EquipmentPartListMonitoring = ({equipment, componentId, equipmentAlertIng}) => {

    const [equipmentParts, setEquipmentParts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();

    useEffect(()=>{
        // console.log(55555)
        if (equipment && equipment.id && componentId && componentId !== -1) {
            getEquipmentPartsWithSensorPositionByQuery({"equipment.id" : equipment.id, "masterEquipmentPart.equipmentCtgr.id": componentId, deletedYn : false}).then((data) => {
                if (data) {
                    const list = data;
                    if (list) {
                        setEquipmentParts(list);
                    }
                } else {
                    setEquipmentParts(null);
                }
                
            })
        }
        setIsLoading(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[componentId, equipment.id, isLoading]);

    function renderContent(type, htmlString) {
        return <TableCell align="center">{htmlString}<EquipmentPartsReplaceLayer info={equipment} type={type} setIsLoading={setIsLoading} /></TableCell>;
        // if (type === "EXPIRED") {
        //     return <TableCell align="center">{htmlString}<EquipmentPartsReplaceLayer info={equipment} type={type} setIsLoading={setIsLoading} /></TableCell>;
        // } else if (type === "NORMAL" || type === "ALERT") {
        //     return <TableCell align="center" dangerouslySetInnerHTML={{ __html: htmlString }}></TableCell>;
        // } else {
        //     return <TableCell align="center"></TableCell>;
        // }
    }

    if (isLoading) {
    return (
        <>
        {/* {((equipment?.equipmentCtgr?.parent?.parent?.code === 'EV' || equipment?.equipmentCtgr?.parent?.parent?.code === 'ES') && componentId === -1) ? */}
        {((equipment?.latestEquipmentOp) && componentId === -1) ?
            <EquipmentPanel equipment={equipment} />
        : 
        equipmentParts && equipmentParts.map(function(item, i) {
            let componentName = item.masterEquipmentPart.name;
            // if (item.status === 'NORMAL') {
            //     componentName += '<span class="instate1">'+t('message.common.text.available')+'</span>';
            // } else if (item.status === 'ALERT') {
            //     componentName += '<span class="instate2">'+t('message.common.text.imminent')+'</span>';
            // } else if (item.status === 'EXPIRED') {
            //     // componentName += '<span class="instate3">'+t('message.common.text.lapse')+'</span>';
            //     // componentName += '---<EquipmentPartsReplaceLayer info={equipment} />';
            // }
            // const sensorPositions = (item.sensorPositions ? (item.sensorPositions).split(",") : []);
            return (
            <div key={i}>
                <MainCard className="center_table" content={false}>
                    <TableContainer>
                        <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width">
                            <TableBody>
                                <TableRow>
                                    <TableCell className="th" align="center">{item.sensorYn ? t('message.common.subtitle.iot.diagnosis.equipment') : t('message.common.subtitle.material')}</TableCell>
                                    {renderContent(item.status, componentName)}
                                    {/* <TableCell align="center" dangerouslySetInnerHTML={ {__html: componentName} }></TableCell> */}
                                    <TableCell className="th" align="center">{t('message.common.subtitle.position')}</TableCell>
                                    <TableCell align="center"><Chip label={item.position} color="primary" /></TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.last.inspection.date')}</TableCell>
                                    <TableCell align="center">{equipment.latestCommYmd}</TableCell>
                                </TableRow>
                                {equipmentAlertIng && item.faultCodes && item.faultCodes.length > 0 &&
                                <TableRow>
                                    {/* <TableCell className="th" align="center">{equipmentAlertIng.fllwActionType === 'O1_WAIT' ? t('message.common.title.alarm') : t('message.common.title.reference')}</TableCell> */}
                                    <TableCell className="th" align="center">{t('message.common.title.defect')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:'left'}}>
                                    {
                                        item.faultCodes.map(function(codes, idx) {
                                            return (
                                        <div key={idx}>
                                            {codes.subCategoryNm}({codes.categoryNm})
                                        </div> 
                                            )
                                        })
                                    }
                                    </TableCell>
                                </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* {equipment && item.id && item.sensorYn && equipment.gateways && equipment.gateways.length > 0 && equipment.gateways.map(function(gateway, j) {
                        return (
                        <EquipmentPartSensorsMonitoring key={j} equipment={equipment} equipmentPartId={item.id} equipmentPartPosition={item.position} gateway={gateway}/>
                        )
                    })} */}
                    {/* {sensorPositions && item.id && item.sensorYn && sensorPositions.length > 0 && sensorPositions.map(function(sPosition, j) { */}
                    {item.id && 
                        <EquipmentPartChainGraphs equipment={equipment} equipmentPartId={item.id} diagnosisResultChain={item.diagnosisResultChain} />
                    }
                    {item.sensorPositions && item.id && item.sensorPositions.length > 0 && item.sensorPositions.map(function(sPosition, j) {
                        return (
                        <EquipmentPartSensorsGraphs key={j} equipment={equipment} equipmentPartId={item.id} equipmentPartPosition={item.position} sensorPosition={sPosition}/>
                        )
                    })}
                </MainCard>
            </div>
            )
        }) 
        }
        </>
    )
    }
}

export default EquipmentPartListMonitoring;